import classNames from "classnames";
import { TitleInterProps } from "./Title";
import { title } from "process";

export const titleClasses = (variant: TitleInterProps["variant"]) => ({
  container: classNames({
    "border-b border-primary mb-2": variant === "h1",
  }),
  title: classNames("font-medium text-slate-500", {
    "text-2xl": variant === "h1",
    "text-xl": variant === "h2",
    "text-lg": variant === "h3",
  }),
});
